var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExploreEvMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.715,
    height: 13.416,
    viewBox: "0 0 17.715 13.416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0.015 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5990",
    "data-name": "Path 5990",
    d: "M17.373.983a.326.326,0,0,0-.326.33v10.48a29.465,29.465,0,0,0-6.429.408,12.846,12.846,0,0,1,5.442-1.052.326.326,0,0,0,.33-.326V.326A.326.326,0,0,0,16.06,0,12.851,12.851,0,0,0,8.847,1.913,12.911,12.911,0,0,0,1.623,0,.326.326,0,0,0,1.3.326v10.5a.326.326,0,0,0,.326.326A12.834,12.834,0,0,1,7.065,12.2,29.428,29.428,0,0,0,.64,11.793V1.314a.33.33,0,1,0-.649,0V12.136a.322.322,0,0,0,.1.237.339.339,0,0,0,.245.09c.057,0,5.846-.31,8.363.95h.065a.261.261,0,0,0,.082,0h.147c2.513-1.261,8.3-.955,8.359-.95a.339.339,0,0,0,.245-.09.322.322,0,0,0,.1-.237V1.314a.326.326,0,0,0-.326-.33ZM15.741,10.5a12.776,12.776,0,0,0-6.56,1.713V2.476A12.169,12.169,0,0,1,15.733.657ZM1.957.657a12.16,12.16,0,0,1,6.56,1.819v9.733A12.776,12.776,0,0,0,1.957,10.5Z",
    transform: "translate(0 0)",
    fill: "#5b788f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExploreEvMenu);
export default __webpack_public_path__ + "static/media/icon_explore_ev_menu.fe4a33a0aa1694231c176519b81e1c5a.svg";
export { ForwardRef as ReactComponent };